/* eslint-disable @nx/enforce-module-boundaries */
import { NotificationIcon, NotificationIconColored } from '@mybridge/icons';
import {
  DropNotifIcon,
  MenuThreeDots,
  SimpleTickIcon,
} from '@mybridge/icons/NotificationIcons';
import {
  HStack,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Box,
  PopoverFooter,
  Button,
  Heading,
  VStack,
  useDisclosure,
  Badge,
  Portal,
  Tooltip,
} from '@mybridge/ui';
import { Text } from '@mybridge/ui/text';
import React, { useEffect, useState } from 'react';
import { ThreeDotsIcon, EmptyNotifIcon } from '@mybridge/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  getNotificationList,
  setGlobalNotificationCount,
  markAllRead,
} from 'v4/store/actions/notification.actions';
import { isBeforeToday, isToday } from 'v4/utils/utils';
import moment from 'moment';
import NotificationCard from './notification-card';
import Link from 'next/link';
import { setMeetingWindowed } from 'v4/store/actions/meeting.actions';
import { Menu, MenuButton, MenuList, MenuItem } from '@mybridge/ui/menu';
import { useRouter } from 'next/router';
import { reverse } from 'lodash';
import { isMobile } from 'react-device-detect';
import { toggleNotificationClicked } from 'v4/store/slices/notificationActiveSlice';
import { setDashboardClicked } from 'v4/store/slices/dashboardAciveSlice';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { Spinner } from '@chakra-ui/react';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
const NotificationDropdown = ({notifDisc, ...props}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { t } = useTranslator();
  const { currentMeetingState } = useSelector((state) => state.meeting);
  const { notificationsList, loading, updatedStatus, globalNotifCount } =
    useSelector((state) => state.notifications);
  // const notifDisc = useDisclosure();
  const todayDate = moment().format('YYYY-MM-DD');
  const [todayNotifs, setTodayNotifs] = useState([]);
  const [earlierNotifs, setEarlierNotifs] = useState([]);
  const [readMessage, setReadMessage] = useState([]);
  const [unreadMessage, setUnreadMessage] = useState([]);
  const [removingIds, setRemovingIds] = useState([]);
  const [isRemovingNotification, setIsRemovingNotification] = useState(false);
  const [removingNotificationId, setRemovingNotificationId] = useState(null);
const { formatNumber } = useNumberFormatter();
  const [unreadCount, setUnreadCount] = useState(0);
  const [unreadListActive, setUnreadListActive] = useState(false);
const [isNotificationPageLoading, setIsNotificationPageLoading] = useState(false);
  const [isNotificationIconLoading, setIsNotificationIconLoading] = useState(false);
  const isNotificationClicked = useSelector(
    (state) => state.notificationActive.isNotificationClicked
  );

  const isToday = (meetingDate) => {
    return moment(meetingDate).format('YYYY-MM-DD') === todayDate;
  };

  const isBeforeToday = (meetingDate) => {
    return moment(meetingDate).isBefore(todayDate);
  };

  const handleRemoveStart = (notificationId) => {
    setIsRemovingNotification(true);
    setRemovingNotificationId(notificationId);
  };

  const handleRemoveComplete = () => {
    // Don't remove spinner immediately - wait for data to be refreshed
    // The spinner will be removed in the useEffect when updatedStatus changes
  };

  const handleReadAllMessage = () => {
    dispatch(
      markAllRead({
        status: 2, // 1 for unread/2 for read/ 2 for archive
      })
    ).then(() => {
      // Update local state immediately
      setUnreadCount(0);
      setUnreadMessage([]);
      setTodayNotifs((prev) =>
        prev.map((notif) => ({ ...notif, status: 2 }))
      );
      setEarlierNotifs((prev) =>
        prev.map((notif) => ({ ...notif, status: 2 }))
      );
    });
   
  };

  const handleUnreadAllMessage = () => {
    dispatch(
      markAllRead({
        status: 1,
      })
    ).then((res) => {
      setUnreadCount(21);
      setUnreadMessage(res?.payload?.data);
      setTodayNotifs((prev) =>
        prev.map((notif) => ({ ...notif, status: 1 }))
      );
      setEarlierNotifs((prev) =>
        prev.map((notif) => ({ ...notif, status: 1 }))
      );
    });
  };

  useEffect(() => {
    dispatch(getNotificationList());
  }, []);

  // Handle notification icon click
  const handleNotificationIconClick = (e) => {
    if (!isNotificationIconLoading) {
      // setIsNotificationIconLoading(true);
      e.stopPropagation();
      dispatch(toggleNotificationClicked());
      dispatch(setDashboardClicked(false));
      notifDisc.onOpen();
    
    }
  };

  useEffect(() => {
    if(router?.pathname === '/notification') {
      setIsNotificationPageLoading(false);
    }
  },[router?.pathname]);
  useEffect(() => {
    setUnreadCount(unreadMessage.length);
  }, [unreadMessage]);
  
 

  useEffect(() => {
    if (globalNotifCount) {
      // dispatch(setGlobalNotificationCount(unreadMessage.length));
      setUnreadCount(globalNotifCount);
    }
  }, [globalNotifCount]);

useEffect(() => {
  if (updatedStatus) {
    // Fetch new notifications first
     dispatch(getNotificationList()).then(() => {
      // Only remove spinner after new data is loaded
      setTimeout(() => {
        setIsRemovingNotification(false);
        setRemovingNotificationId(null);
      }, 200);
    });
  }
}, [updatedStatus]);


  useEffect(() => {
    if (currentMeetingState) {
      dispatch(setMeetingWindowed());
    }
    if (globalNotifCount > 0) {
      dispatch(setGlobalNotificationCount()).then((res) => {
        if (res) {
          setUnreadCount(0);
        }
      });
    }
  }, [notifDisc.isOpen]);

  useEffect(() => {
    if (notificationsList?.length) {
      setTodayNotifs([]);
      setEarlierNotifs([]);
      setUnreadMessage([]);
      setReadMessage([]);
      notificationsList?.slice(0, 22)?.forEach((message) => {
        if (isToday(message.created_at))
          setTodayNotifs((prevState) => [message, ...prevState]);
        else if (isBeforeToday(message.created_at))
          setEarlierNotifs((prevState) => [message, ...prevState]);
        if (message.status === 1)
          setUnreadMessage((prevState) => [message, ...prevState]);
         else if (message.status === 2) 
          setReadMessage((prevState) => [message, ...prevState]);
      });
    }
  }, [notificationsList]);

  // Update your sorting arrays to filter out the removing notification
  const todaysSortArray = todayNotifs
    ?.filter(item => item.id !== removingNotificationId) // Filter out removing notification
    ?.map((item) => ({ ...item, momentDate: moment(item.created_at) }))
    .sort((a, b) => a.momentDate - b.momentDate);
  const earlierSortArray = earlierNotifs
    ?.filter(item => item.id !== removingNotificationId) // Filter out removing notification
    ?.map((item) => ({ ...item, momentDate: moment(item.created_at) }))
    .sort((a, b) => a.momentDate - b.momentDate);
  const unreadSortArray = unreadMessage
    ?.filter(item => item.id !== removingNotificationId) // Filter out removing notification
    ?.map((item) => ({ ...item, momentDate: moment(item.created_at) }))
    .sort((a, b) => a.momentDate - b.momentDate);
const readSortArray=readMessage?.map((item) => ({ ...item, momentDate: moment(item.created_at) }))
.sort((a,b) => a.momentDate - b.momentDate);
  return (
    <Popover {...notifDisc}>
      <PopoverTrigger onClick={() => notifDisc.onOpen()}>
         {isNotificationPageLoading ? (
          <Box width="60px" display="flex" justifyContent="center" alignItems="center">
            <Spinner size="lg"/>
          </Box>
        ) : (
        <IconButton
          bg="transparent"
          position="relative"
          // px={[1, 2, 8]}
          size={isMobile ? 'sm' : 'md'}
          // variant="homeHeaderButtons"
          isActive={router?.pathname === '/notification' ? true : false}
          fill={"red"}
          borderRadius="50px"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(toggleNotificationClicked());
            if(!notifDisc.isOpen) {
              dispatch(getNotificationList());
            }
            dispatch(setDashboardClicked(false));
          }}
        >
          <>
            {unreadCount > 0 && unreadCount<=20 ? (
              <Badge
                position="absolute"
                bg="brandRed.500"
                color="white"
                borderRadius="100%"
                top="0"
                minW="25px"
                border="2px solid #ffffff"
                lineHeight="normal"
                p="3px 5px"
                left="50%"
                zIndex="3"
                px={0}
              >
                {formatNumber(unreadCount)}
              </Badge>
            ) : unreadCount>20 && (
              <Badge
                position="absolute"
                bg="brandRed.500"
                color="white"
                borderRadius="100%"
                top="-4px"
                minW="25px"
                border= '2px solid #ffffff'
                p="5px 2px"
                lineHeight="normal"
                left="35%"
                fontSize="10px"
              >
                {formatNumber(20)+"+"}
              </Badge>
            )}

            <Tooltip label={t('common.notifications') || "Notifications"} bg="black" p={2} isDisabled={notifDisc?.isOpen}>
              <Box as="span">
                <NotificationIconColored
                  width={isMobile && !props.width? '26' : props.width}
                  height={isMobile && !props.height ? '26' : props.height}
                  color={isNotificationClicked ? "#4170A4" : '#5B5B5B'}
                />
              </Box>
            </Tooltip>
          </>
        </IconButton>
         )}
      </PopoverTrigger>
      <Portal>
        <PopoverContent 
          borderRadius={"15px"} 
          boxShadow="0px 2px 6px 0px rgba(0, 0, 0, 0.2)" 
          width={['100vw', '400px', '400px']}
          position="relative"
        >
          {/* Add overlay spinner for remove actions */}
          {(isRemovingNotification) && (
            <Box
              position="absolute"
              top="0"
              left="0"
              right="0"
              bottom="0"
              bg="rgba(255, 255, 255, 0.9)"
              display="flex"
              alignItems="center"
              justifyContent="center"
              zIndex="1000"
              borderRadius="15px"
            >
              <VStack spacing={3}>
                <Spinner size="lg" color="blue.500" thickness="3px" />
                {/* <Text fontSize="sm" color="gray.600">
                  {isRemovingNotification 
                    ? (t('notification.removing') || "Removing notification...") 
                    : (t('notification.updating') || "Updating notifications...")
                  }
                </Text> */}
              </VStack>
            </Box>
          )}

          <PopoverHeader border="0px">
            <HStack justifyContent="space-between">
              <Text fontSize="md" fontWeight="bold">
              {t('common.notifications') || "Notifications"}
              </Text>
              <Menu>
                <MenuButton
                  as={IconButton}
                  variant="transparent"
                  p={0}
                  w="12px"
                  h="10px"
                  justifyContent="center"
                  icon={<MenuThreeDots width={11} height={4} />}
                />
                <MenuList>
                  <MenuItem
                    onClick={() => handleReadAllMessage()}
                    variant="transparent"
                  >
                  
                    <SimpleTickIcon /> <Text ms={3}>{t('notification.MarkAllRead') || "Mark all as read"}</Text>
                  </MenuItem>
                  <MenuItem
                    onClick={() => handleUnreadAllMessage()}
                    variant="transparent"
                  >
                  
                    <SimpleTickIcon /> <Text ms={3}>{"Mark all as Unread"}</Text>
                  </MenuItem>
                  <MenuItem
                    onClick={() => router.push('/notification')}
                    variant="transparent"
                  >
                    <DropNotifIcon />
                   
                    <Text ms={3}> {t('notification.openNotifications') || "Open Notifications"}</Text>
                  </MenuItem>
                  <MenuItem
                    onClick={() => router.push('/settings/notifications')}
                    variant="transparent"
                  >
                    <DropNotifIcon />
                    
                    <Text ms={3}>{t('notification.notificationSettings') || "Notification Settings"}</Text>
                  </MenuItem>
                </MenuList>
              </Menu>
              {/* <ThreeDotsIcon /> */}
            </HStack>
          </PopoverHeader>
          <PopoverBody py="15px">
            <Tabs
              variant="soft-rounded"
              colorScheme="gray"
              minH="400px"
              maxH="400px"
              overflow="auto"
            >
              <TabList>
                <Tab py="2px">{t('publicProfile.all') || "All"}</Tab>
                <Tab py="2px">{t('teams.unread') || "unread"}</Tab>
                 <Tab py="2px">{t('notification.Read') || "read"}</Tab>
              </TabList>
              <TabPanels>
                <TabPanel px="0">
                  {!loading && notificationsList && (todayNotifs.length > 0 || isRemovingNotification) ? (
                    <>
                      <Text fontWeight="bold">{t('profileNetwork.new') || "New"}</Text>
                      {todaysSortArray?.reverse().map((message, i) => (
                        <NotificationCard
                          key={i}
                          details={message}
                          onClose={() => notifDisc.onClose()}
                          onRemoveStart={() => handleRemoveStart(message.id)}
                          onRemoveComplete={handleRemoveComplete}
                        />
                      ))}
                    </>
                  ) : (
                    ''
                  )}
                  {!loading && notificationsList && (earlierNotifs.length > 0 || isRemovingNotification) ? (
                    <>
                      <Text fontWeight="bold">{t('profileNetwork.earlier') || "Earlier"}</Text>
                      {earlierSortArray?.reverse().map((message, i) => (
                        <NotificationCard
                          key={i}
                          details={message}
                          onClose={() => notifDisc.onClose()}
                          onRemoveStart={() => handleRemoveStart(message.id)}
                          onRemoveComplete={handleRemoveComplete}
                        />
                      ))}
                    </>
                  ) : (loading)?(
                    <Box display='flex' justifyContent='center' alignItems="center" minH="300px" py="25px" w="100%">
                      <Spinner/>
                    </Box>
                  ):( 
                    !todayNotifs.length && !isRemovingNotification && (
                      <Box align="center" py="25px" w="100%">
                        <EmptyNotifIcon />
                      </Box>
                    )
                  )}
                </TabPanel>
                <TabPanel px="0">
                  {!loading && notificationsList && (unreadMessage.length > 0 || isRemovingNotification) ? (
                    <>
                      <Text fontWeight="bold">{t('profileNetwork.new') || "New"}</Text>
                      {unreadSortArray?.reverse().map((message, i) => (
                        <NotificationCard
                          key={i}
                          details={message}
                          onClose={() => notifDisc.onClose()}
                          onRemoveStart={() => handleRemoveStart(message.id)}
                          onRemoveComplete={handleRemoveComplete}
                        />
                      ))}
                    </>
                  ) : (
                    !isRemovingNotification && (
                      <Box align="center" py="25px" w="100%">
                        <EmptyNotifIcon />
                      </Box>
                    )
                  )}
                </TabPanel>
                 <TabPanel px="0">
    {!loading && notificationsList && (readMessage.length > 0 || isRemovingNotification) ? (
      <>
        <Text fontWeight="bold">{t('notification.Read') || "Read"}</Text>
        
        {readSortArray?.reverse().map((message, i) => (
          <NotificationCard
            key={i}
            details={message}
            onClose={() => notifDisc.onClose()}
            onRemoveStart={() => handleRemoveStart(message.id)}
            onRemoveComplete={handleRemoveComplete}
          />
        ))}
      </>
    ) : (
      !isRemovingNotification && (
        <Box align="center" py="25px" w="100%">
          <EmptyNotifIcon />
        </Box>
      )
    )}
  </TabPanel>

              </TabPanels>
            </Tabs>
          </PopoverBody>
          <PopoverFooter align="center" justifyContent="center" display="flex">
            <Link href="/notification" variant="transparent">
              <Button variant="transparent" onClick={() => {
                notifDisc.onClose();
                setIsNotificationPageLoading(true);
                }}>
              {t('notification.allNotifications') || "All Notifications"}
                
              </Button>
            </Link>
          </PopoverFooter>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default NotificationDropdown;
